module.exports = __webpack_public_path__ + "media/cloud.49c3a8cc.mp4";